import React from 'react';
import { FormattedMessage } from 'react-intl';

import { OptionFormTypes } from '../../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../../services/filtering/filter-form-render-service';
import type { CriteriaInformations } from '../../../../../../pages/products-page/purchase-orders/filter-options/types';
import { dateMessages } from './messages';

export const CREATE_DATES = 'createDates';

export default {
  id: CREATE_DATES,
  displayName: () => <FormattedMessage {...dateMessages.createDate} />,
  type: OptionFormTypes.TYPE_DATE_COMPARISON_SHIPMENTS,
  filterValue: CREATE_DATES,
  render: (criteriaInformations: CriteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_DATE_COMPARISON_SHIPMENTS, criteriaInformations);
  },
};
